import { makeAutoObservable, runInAction } from 'mobx';
import NotificationApi from '../api/endpoints/NotificationApi';
import LogUtil from '../helpers/LogUtil';
import { Trigger, TriggerType } from '../Trigger.types';
import { RootStore } from './RootStore';

export class NotificationStore {
	rootStore: RootStore;
	notifications: any[] = []; // @todo fix type plz
	isLoading: boolean = false;

	constructor(rootStore: RootStore) {
		makeAutoObservable(this, { rootStore: false });
		this.rootStore = rootStore;

		this.processTrigger = this.processTrigger.bind(this);
		this.init();
	}

	init() {
		this.rootStore.userStore.UserIdChanged.on(() => {
			this.loadNotifications();
		});

		this.rootStore.userStore.SignedOut.on(() => {
			runInAction(() => {
				this.notifications = [];
			});
		});
	}

	async processTrigger(trigger: Trigger<any>) {
		try {
			switch (trigger.urn) {
				case TriggerType.NOTIFICATION_CLEARED:
					if (trigger.event?.data?.notificationIds) {
						this.removeNotifications(trigger.event.data.notificationIds);
					}
					break;
				case TriggerType.NOTIFICATION_NEW:
					if (trigger.event?.data?.id) {
						this.addNotification(trigger.event.data);
					}
					break;
			}
		} catch (err) {
			LogUtil.error(err);
		}
	}

	get unread() {
		return this.notifications.length;
	}

	async loadNotifications() {
		if (!this.isLoading) {
			this.isLoading = true;
			const result = await NotificationApi.getNotifications();
			if (result.statusCode === 200 && result.data) {
				runInAction(() => {
					this.notifications = result.data;
				});
			}

			runInAction(() => {
				this.isLoading = false;
			});
		}
	}

	async clearNotifications(notificationIds: string[]) {
		const result = await NotificationApi.clearNotifications(notificationIds);
		if (result.statusCode === 200) {
			this.removeNotifications(notificationIds);
		}
	}

	removeNotifications(notificationIds: string[]) {
		runInAction(() => {
			this.notifications = this.notifications.filter(
				(notification: any) => !notificationIds.includes(notification.id)
			);
		});

		if (this.unread < 10) {
			this.loadNotifications();
		}
	}

	addNotification(notification: any) {
		runInAction(() => {
			this.notifications.push(notification);
		});
	}
}
